<div>
    <dx-report-viewer [reportUrl]="reportUrl" #dxViewer [width]="'100%'" height="800px">
        <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrl"></dxrv-request-options>
        <dxrv-callbacks (CustomizeMenuActions)="CustomizeMenuActions($event)" (OnServerError)="OnServerError($event)"
            (DocumentReady)="OnDocumentReady($event)" (ParametersSubmitted)="OnParameterSubmitted()"> </dxrv-callbacks>
    </dx-report-viewer>
</div>